import { BaseApi } from './base';

export interface PushVapidKeyResponse {
  publicKey: string;
}

export interface PushSubscriptionPayload {
  subscription: PushSubscriptionJSON;
  userAgent?: string;
}

export interface PushUnsubscribePayload {
  endpoint: string;
}

export class PushApi extends BaseApi {
  public async getVapidKey(): Promise<PushVapidKeyResponse> {
    return await this._request<PushVapidKeyResponse>('/push/vapid-public-key', {
      method: 'GET',
    });
  }

  public async subscribe(payload: PushSubscriptionPayload): Promise<void> {
    await this._request<void>('/push/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  }

  public async unsubscribe(payload: PushUnsubscribePayload): Promise<void> {
    await this._request<void>('/push/unsubscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  }
}
